import { z } from "zod";

/** Sansan APIキーの形式（Sansan APIドキュメント: 32桁の英数字）。 */
const SANSAN_API_KEY_PATTERN = /^[A-Za-z0-9]{32}$/;

export const SansanApiKeyFormSchema = z.object({
  apiKey: z
    .string()
    .min(1, { message: "APIキーを入力してください" })
    .regex(SANSAN_API_KEY_PATTERN, {
      message: "APIキーは32桁の英数字で入力してください",
    }),
});

export type SansanApiKeyFormData = z.infer<typeof SansanApiKeyFormSchema>;
